import {
    CONFIRMED_GET_AVALIBILITY_STATUS
} from '../actions/AvailabilityStatus/AvailabilityStatusTypes';
const initialState = {
    availabilityStatus: [],
    loading: false,
};

function AvailabilityStatusReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'AVAILABILITY_STATUS_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_AVALIBILITY_STATUS:
            return {
                ...state,
                availabilityStatus: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {AvailabilityStatusReducer};